export default "__VITE_ASSET__DqFZjGGR__"